module.exports = __webpack_public_path__ + "img/ico-gear.525d2e13.svg";